import { useEffect, useState } from 'react';

import Input from 'common-ui/input';
import Modal from 'common-ui/modal';
import Select from 'common-ui/select/Select';

import { ModalFormContent } from '../Addresses.styles';

const RegionModal = ({ isOpen, onClose, onSubmit, region, countries, loading }) => {
  const [name, setName] = useState('');
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (region) {
      setName(region.name || '');
      if (region.countryId && countries) {
        const country = countries.find((c) => c.id === region.countryId);
        if (country) {
          setSelectedCountry({ value: country.id, label: country.name });
        }
      }
    } else {
      setName('');
      setSelectedCountry(null);
    }
    setError('');
  }, [region, countries, isOpen]);

  const handleSubmit = () => {
    if (!name.trim()) {
      setError('Region name is required');
      return;
    }

    if (!selectedCountry) {
      setError('Please select a country');
      return;
    }

    onSubmit({ name: name.trim(), countryId: selectedCountry.value });
  };

  const handleClose = () => {
    setName('');
    setSelectedCountry(null);
    setError('');
    onClose();
  };

  const countryOptions = countries
    ? countries.map((country) => ({
        value: country.id,
        label: country.name,
      }))
    : [];

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      onOk={handleSubmit}
      title={region ? 'Edit Region' : 'Create Region'}
      okText={region ? 'Update' : 'Create'}
      cancelText="Cancel"
      footer
      closeIcon
      width="450px"
      onOkLoading={loading}
    >
      <ModalFormContent>
        <Select
          label="Country"
          req
          value={selectedCountry}
          onChange={(option) => {
            setSelectedCountry(option);
            setError('');
          }}
          options={countryOptions}
          placeholder="Select a country"
          isClearable
        />
        <Input
          label="Region Name"
          required
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            setError('');
          }}
          error={error}
          fullWidth
          placeholder="Enter region name"
        />
      </ModalFormContent>
    </Modal>
  );
};

export default RegionModal;
